import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  ...theme.paddings(0),
  gap: 15,
  backgroundColor: theme.palette.white,
  borderRadius: 10,
  border: "1px solid rgba(37, 99, 235, 0.3)",
  overflow: "hidden",
}));

export const BlockTitle = styled("h3")(({ theme }) => ({
  fontSize: 18,
  fontWeight: 600,
  color: theme.palette.text.primary,
  padding: "20px 24px",
  borderBottom: `1px solid ${theme.palette.border.light}`,
  margin: 0,

  [theme.down("sm")]: {
    fontSize: 16,
    padding: "15px 15px",
  },
}));

export const PassengersBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  gap: 20,
  padding: "20px 24px",

  [theme.down("sm")]: {
    padding: "15px 15px",
    gap: 15,
  },
}));
